import { render } from "./headerComponent.vue?vue&type=template&id=108848ec&scoped=true"
import script from "./headerComponent.vue?vue&type=script&lang=js"
export * from "./headerComponent.vue?vue&type=script&lang=js"

import "./headerComponent.vue?vue&type=style&index=0&id=108848ec&scoped=true&lang=css"

import exportComponent from "F:\\work\\rahul\\mangal karyala\\gore-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108848ec"]])

export default __exports__